import { Box, Badge, SpaceBetween } from '@cloudscape-design/components';

interface ExpressionEditorProps {
  expression: string;
  language: string;
}

export function ExpressionEditor({ expression, language }: ExpressionEditorProps) {
  return (
    <SpaceBetween size="s">
      <Box>
        <Badge color="blue">{language}</Badge>
      </Box>
      <Box variant="code">
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'monospace', fontSize: '14px', lineHeight: '1.6', padding: '12px', backgroundColor: '#1b1f27', color: '#d1d5db', borderRadius: '8px', overflowX: 'auto' }}>
          {expression}
        </pre>
      </Box>
    </SpaceBetween>
  );
}
